const BASE_URL = process.env.REACT_APP_API_URL;

const API = {
  BASE_URL: `${BASE_URL}`,
  FETCH_VIDEOS_URL: `${BASE_URL}/videos`,
};

export default API;
